@for (round of data; track $index) { @if (round.pairings.length > 1) {
<div class="mb-4">
    <h3 class="ml-2">@if (round.playoff) { PLAYOFF - }{{ round.round }}. {{ 'web.round' | translate }}</h3>
    <div class="d-flex table-scrollable">
        <div class="table-scrollable__fixed">
            <div class="table-scrollable__fixed-shadow"></div>
            <table class="table-scrollable__fixed__table stage-table golf-table-list">
                <thead>
                    <tr class="bg-light">
                        <th class="table-scrollable__table-th font-weight-normal pl-2">{{ 'web.time' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    @for (pairing of round.pairings; track $index) {
                    <tr class="table-scrollable__table-row app-cursor">
                        <td class="table-scrollable__table-td pl-2">
                            {{ pairing.time | livDate : 'localDateTimeShort' }}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="table-scrollable__data flex-grow-1" tableScroll>
            <table class="table-scrollable__data__table stage-table golf-table-list">
                <thead>
                    <tr class="bg-light">
                        @for (participant of round.pairings[1].participants; track $index) {
                        <th class="table-scrollable__table-th table-scrollable__data__table-th vab"></th>
                        }
                    </tr>
                </thead>
                <tbody>
                    <ng-container>
                        @for (pairing of round.pairings; track $index) {
                        <tr class="table-scrollable__table-row app-cursor">
                            @for (participant of pairing.participants; track $index) {
                            <td class="table-scrollable__table-td table-scrollable__data__table-td text-left">
                                <a
                                    [routerLink]="['/page/golf/participant/golf-62/', participant.id]"
                                    class="text-reset"
                                >
                                    @if (participant.iso) {
                                    <img
                                        src="/img/flags/1x1/{{ participant.iso | lowercase }}.svg"
                                        alt=""
                                        class="rounded-circle mr-2"
                                        height="20"
                                    />
                                    } @if (!participant.iso) {
                                    <img src="/img/default-avatar.png" alt="" class="rounded-circle mr-2" height="20" />
                                    }
                                    {{ participant.name }}
                                </a>
                            </td>
                            }
                        </tr>
                        }
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
} }
